/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

    /* === Promo Block Section === */

    const promoApply = document.querySelector('.promo-apply');

    function applyPromo(e) {
        const xhr = new XMLHttpRequest();
        const currentTarget = e.currentTarget;

        xhr.open('GET', '/discount/' +  currentTarget.dataset.promoCode, true);
        xhr.send();

        xhr.onreadystatechange = function() {
            if (xhr.readyState !== 4) return;
            currentTarget.classList.remove('promo-apply--loading');

            if (xhr.status === 200) currentTarget.classList.add('promo-apply--applied');
        };

        currentTarget.classList.add('promo-apply--loading');
    }

    promoApply.addEventListener('click',  applyPromo);

    /* === Promo Block Section End === */


  
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
